import React, { useState, useEffect } from "react";
import LocationList from "../Components/Location";
import API from "../Services/Location";

import API1 from '../Services/Product';
import API2 from '../Services/ProductType'
import APIS from '../Services/SalesTab'
import moment from "moment";
import APISS from '../Services/Location'
import CenterSalesTab from "../Components/CenterSalesTab";
import ComboProduct from "../Components/ComboProduct";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DisplayOrder from "../Components/DisplayOrder";

const ManageCenter = () => {
    const [locationId, setLocationId] = useState("");
    const [getSalesTab, setSalesTab] = useState([]);
    //  const [salesTab, setSalesTab] = useState([])
    const [productType, setProductType] = useState([]);
    const [product, setProduct] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [currentPageProduct, setCurrentPageProduct] = useState(1);
    const perPage = 10;

    const [salesTabId, setSalesTabId] = useState(null);
    const [fetchDetails, setFetchDetails] = useState("");
    const [trigger, setTrigger] = useState(0);
    // ----------------------------------------------------------------------

    const [name, setName] = useState("")
    const [saleTabName, setSaleTabName] = useState([])
    const [buttonColor, setButtonColor] = useState("")
    const [displayOrder, setDisplayOrder] = useState([])
    const [location, setLocation] = useState([])
    const [trackInventory, setTrackInventory] = useState("")
    const [isCombo, setISCombo] = useState("")
    const [isShowtoCustomer, setIsShowtoCustomer] = useState("")
    const [selectSalesTab, setSelectSalesTab] = useState("")
    const [error, setError] = useState({});
    const [productList, setProductList] = useState([])
    const [id, setId] = useState([])

    const [selectedLocation, setSelectedLocation] = useState([])
    const [isRecipe, setIsRecipe] = useState("")
    const [search, setSearch] = useState("")
    const [waiverRequired, setWaiverRequired] = useState("")
    const [showTable, setShowTable] = useState(false);


        const handleSearch = async () => {
            try {
                const response = await API.getLocationBaseData(locationId);
                const details = response?.data?.data;

                // setSalesTab(details?.sales_tab || []);

                // setProductType(details?.product_type || []);
                // setProduct(details?.product || []);

                 const activeSalesTab = (details?.sales_tab || []).filter(item => item.is_active);
                 setSalesTab(activeSalesTab);
                 const activeProductType=(details?.product_type || []).filter(item => item.is_active)
                 setProductType(activeProductType);
                 const activeProduct=(details?.product || []).filter(item => item.is_active)
                setProduct(activeProduct);
                // setProductType(details?.product_type || []).filter(item => item.is_active);
                // setProduct(details?.product || []).filter(item => item.is_active);

                // console.log('details?.product', details?.product);
                setCurrentPage(1);
                setCurrentPage1(1);
                setCurrentPageProduct(1);
                setShowTable(true);
            } catch (error) {
                if (error.response?.status === 403) {
                    window.location.replace("/Login");

                } else {
                    console.error("An unexpected error occurred:", error);

                }
            }
        };

    // const handleGetSalesTabes = async (id) => {
    //     console.log('id', id)
    //     setSalesTabId(id);
    // }
    const handleGetSalesTabes = (id) => {
        console.log('id', id);
        setSalesTabId(id);
        setTrigger(prev => prev + 1); // force update even if same id
    };
    const bindSalesTab = async (location) => {
        try {
            if (location === "Select") {
                // console.log('ddd')
                setSalesTab([]);
                return;
            }
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 10,
                pageNumber: 1,
                search: location,
            });
            setSaleTabName(response?.data?.data || []);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        bindLocation()
    }, [])

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            setError("Failed to fetch locations.");
            console.error(error);
        }
    };

    const handleGetProductTypeData = async (productId) => {

        try {
            const response = await API2.Get_Product_Type({ id: productId });
            const fetchedData = response?.data?.data[0];
            //  console.log("fetchdata111111111", fetchedData)
            if (fetchedData) {

                setId(fetchedData.id);
                setName(fetchedData?.name);
                setButtonColor(fetchedData?.button_color_id);
                setDisplayOrder(fetchedData?.display_order);
                setSelectedLocation(fetchedData?.location_id);
                setSelectSalesTab(fetchedData?.sale_tab_id);
                setTrackInventory(fetchedData?.track_inventory);
                setISCombo(fetchedData?.is_combo);
                setIsShowtoCustomer(fetchedData?.show_to_customer)
                bindSalesTab(fetchedData?.location_id);
                setWaiverRequired(fetchedData?.is_waiver_required);

                let weekdaysObject = {};
                const weekdaysArray = fetchedData?.week_list
                    ? fetchedData?.week_list.split(", ").map(day => day.trim())
                    : [];
                if (weekdaysArray.includes("All Days")) {
                    weekdaysObject = {
                        Monday: false,
                        Tuesday: false,
                        Wednesday: false,
                        Thursday: false,
                        Friday: false,
                        Saturday: false,
                        Sunday: false,
                    };
                } else {
                    weekdaysObject = {
                        Monday: weekdaysArray.includes("Monday"),
                        Tuesday: weekdaysArray.includes("Tuesday"),
                        Wednesday: weekdaysArray.includes("Wednesday"),
                        Thursday: weekdaysArray.includes("Thursday"),
                        Friday: weekdaysArray.includes("Friday"),
                        Saturday: weekdaysArray.includes("Saturday"),
                        Sunday: weekdaysArray.includes("Sunday"),
                    };
                }
                setWeekdays(weekdaysObject);
                // setIsEditing(true);

            } else {
                toast.error("Failed to fetch product Type details.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };
    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });

    const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const handleWeekdayChange1 = (day) => {
        setWeekdays((prevWeekdays) => ({
            ...prevWeekdays,
            [day]: !prevWeekdays[day],
        }));
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updateProductData();

    };

    const updateProductData = async () => {
        //  if (!displayOrder || displayOrder === "Select") {
        //     toast.error("Display Order is required");
        //     return;
        // }
         if (!selectSalesTab || selectSalesTab === "Select") {
            toast.error("Sales Tab is required");
            return;
        }
           
        const selectedDays = Object.keys(weekdays)
            .filter((day) => weekdays[day])
            .join(", ");
        const weekList = selectedDays || "All Days";
        const updatedTrackInventory = Boolean(trackInventory);
        const updatedIsCombo = Boolean(isCombo);
        const updatedIsShowCutomer = Boolean(isShowtoCustomer);
        const updatedIsRecipe = Boolean(isRecipe);
        const updateWaiverRequred = Boolean(waiverRequired)
       

       
        try {
            const payload = {
                name,
                sale_tab_id: selectSalesTab || 0,
                // button_color_id: buttonColor,
                display_order: displayOrder || 0,
                location_id: selectedLocation,
                track_inventory: updatedTrackInventory,
                is_combo: updatedIsCombo,
                is_recipe: updatedIsRecipe,
                week_list: weekList,
                show_to_customer: updatedIsShowCutomer,
                is_waiver_required: updateWaiverRequred
            };
            const response = await API2.updateProductType(id, payload);

            // console.log('payload', payload);

            if (response?.status === 200) {
                toast.success(response?.data?.message || "Product Type Status Updated Successfully!");
                setTimeout(() => window.location.reload(), 2000);
                handleSearch();
                // productType();
                // getProductList();

            } else {
                toast.error(response?.data?.message || "Failed to update Product Type. Please try again.");
            }
        } catch (error) {
            console.error("Error updating product:", error);
            toast.error("An unexpected error occurred. Please try again later.");
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectSalesTab(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.saleTabName;
            return updatedErrors;
        });
    };

    const handleChange1 = (e) => {
        const value = e.target.value;
        // console.log("value data id",value)
        setSelectedLocation(value);
        bindSalesTab(value)
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.saleTabName;
            return updatedErrors;
        });
    };


    const validateFields = () => {
        const errors = {};
        if (!name.trim()) errors.name = "Name is required";
        // if (!displayOrder) {
        //     errors.displayOrder = "Display order is required";
        // }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "selectSalesTab":
                setSelectSalesTab(value);
                break;
            case "selectedLocation":
                setSelectedLocation(value);
                break;
            case "displayOrder":
                setDisplayOrder(value);
                break;
            case "isRecipe":
                setIsRecipe(value);
                break;
            default:
                break;
        }
    };

    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const totalPages = Math.ceil(getSalesTab.length / perPage);
    const currentData = getSalesTab.slice((currentPage - 1) * perPage, currentPage * perPage);

    const totalPages1 = Math.ceil(productType.length / perPage);
    const currentData1 = productType.slice((currentPage1 - 1) * perPage, currentPage1 * perPage);


    const totalPagesProduct = Math.ceil(product.length / perPage);
    const currentDataProduct = product.slice((currentPageProduct - 1) * perPage, currentPageProduct * perPage);

    const renderPagination = (currentPage, totalPages, onPageChange) => {
        const pageStart = Math.max(currentPage - 2, 1);
        const pageEnd = Math.min(pageStart + 4, totalPages);


        return (
            <ul className="pagination justify-content-center mt-4">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                </li>
                {Array.from({ length: pageEnd - pageStart + 1 }, (_, i) => {
                    const page = pageStart + i;
                    return (
                        <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(page)}>{page}</button>
                        </li>
                    );
                })}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </li>
            </ul>
        );
    };

    const handleGetData = async (productId, combo) => {

        try {
            const response = await API1.Get_Product({ id: productId });
            const data = response?.data?.data?.[0];
            if (!data) return toast.error("Failed to fetch product details.");

            setFetchDetails(data);

        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            toast.error("An error occurred while fetching product details.");
        }
    };

    const handleGetProductData = (id, combo) => {
        // console.log('dddd',id);
        handleGetData(id, combo);
    };


    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Manage Center</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <LocationList
                                    selectedLocation={locationId}
                                    setSelectedLocation={(location) => {
                                        setLocationId(location);
                                        if (location.trim()) {
                                            setError((prevErrors) => {
                                                const updatedErrors = { ...prevErrors };
                                                delete updatedErrors.locationId;
                                                return updatedErrors;
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-success mt-4" type="button" onClick={handleSearch}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    {showTable && (
                        <section>
                            {/* Sales Tab Table */}
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h4 className="card-title mb-0">Total Sales Tab</h4>
                                </div>
                                <div className="card-body text-center">
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Action</th>
                                                    <th>Tab Name</th>
                                                    <th>Display Order</th>
                                                    <th>Price Type</th>
                                                    <th>Button Color</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentData.length > 0 ? (
                                                    currentData.map((item, index) => (
                                                        <tr key={item.id || index}>

                                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                            <td><button className="btn btn-primary btn-sm" onClick={() => handleGetSalesTabes(item.id)}>Edit</button></td>
                                                            <td>{item?.tab_name}</td>
                                                            <td>{item?.display_order}</td>
                                                            <td>{item?.price_type}</td>
                                                            <td>{item?.button_color_name}</td>
                                                            <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6">No Record found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {currentData.length > 0 && (
                                            <nav aria-label="Sales Tab pagination">
                                                {renderPagination(currentPage, totalPages, setCurrentPage)}
                                            </nav>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Product Type Table */}
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h4 className="card-title mb-0">Total Product Type</h4>
                                </div>
                                <div className="card-body text-center">
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Action</th>
                                                    <th>Name</th>
                                                    <th>Sales Tab Name</th>
                                                    <th>Track Inventory</th>
                                                    <th>Is Combo</th>
                                                    <th>Week List</th>
                                                    <th>Waiver Required</th>
                                                    <th>Show to Customer</th>
                                                    <th>Button Color</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentData1.length > 0 ? (
                                                    currentData1.map((item, index) => (
                                                        <tr key={item.id || index}>
                                                            <td>{(currentPage1 - 1) * perPage + index + 1}</td>
                                                            <td> <button onClick={() => handleGetProductTypeData(item.id)}
                                                                className="btn btn-primary btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModaltypeEdit"
                                                            >
                                                                Edit
                                                            </button></td>
                                                            <td>{item.name}</td>
                                                            <td>{item.sales_tab_name}</td>
                                                            <td>{item.track_inventory ? "True" : "False"}</td>
                                                            <td>{item.is_combo ? "True" : "False"}</td>
                                                            <td>{item.week_list}</td>
                                                            <td>{item.is_waiver_required ? "True" : "False"}</td>
                                                            <td>{item.show_to_customer ? "True" : "False"}</td>
                                                            <td>{item.button_color_name}</td>
                                                            <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10">No Record found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <div>
                                            {currentData1.length > 0 && (
                                                <nav aria-label="Product Type pagination">
                                                    {renderPagination(currentPage1, totalPages1, setCurrentPage1)}
                                                </nav>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Product Table */}
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h4 className="card-title mb-0">Total Product</h4>
                                </div>
                                <div className="card-body text-center">
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Action</th>
                                                    <th>Name</th>
                                                    <th>Sales Tab Name</th>
                                                    <th>Product Type</th>
                                                    <th>Display Order</th>
                                                    <th>SkyCoins</th>
                                                    <th>Description</th>
                                                    <th>Is Recipe</th>
                                                    <th>Created Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentDataProduct.length > 0 ? (
                                                    currentDataProduct.map((item, index) => (
                                                        <tr key={item.id || index}>
                                                            <td>{(currentPageProduct - 1) * perPage + index + 1}</td>
                                                            <td>
                                                                <button onClick={() => handleGetProductData(item.id, item?.is_combo)}
                                                                    className="btn btn-primary btn-sm" type="button"
                                                                >
                                                                    Edit
                                                                </button>

                                                            </td>
                                                            <td>{item.name}</td>
                                                            <td>{item.sale_tab_name}</td>
                                                            <td>{item.product_type_name}</td>
                                                            <td>{item.display_order}</td>
                                                            <td>{item.amount}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.is_recipe ? "True" : "False"}</td>
                                                            <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10">No Record found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {currentDataProduct.length > 0 && (
                                            <nav aria-label="Product pagination">
                                                {renderPagination(currentPageProduct, totalPagesProduct, setCurrentPageProduct)}
                                            </nav>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </section>
                    )}
                </div>
            </div>

            <section>
                <div className="modal" id="myModaltypeEdit" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Product Type</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-1">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="txtname" className="form-label">
                                                Name <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}
                                            />
                                            {error.name && <small className="text-danger">{error.name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Center <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select className="form-select"
                                                id="ddSalesType"
                                                value={selectedLocation}
                                                onChange={handleChange1}
                                            >
                                                <option>Select</option>
                                                {Array.isArray(location) ? location.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                )) : null}
                                            </select>
                                            {error.location && <small className="text-danger">{error.location}</small>}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Sales Tab <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select className="form-select"
                                                id="ddSalesType"
                                                value={selectSalesTab}
                                                onChange={handleChange} >
                                                <option>Select</option>
                                                {saleTabName.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tab_name}
                                                    </option>
                                                ))}
                                            </select>
                                            {error.saleTabName && <small className="text-danger">{error.saleTabName}</small>}
                                        </div>
                                    </div>

                                </div>
                                <div className="row mb-3">

                                    <div className="col-md-3">
                                        <DisplayOrder
                                            selectedDisplayOrder={displayOrder}
                                            setSelectedDisplayOrder={(color) => {
                                                setDisplayOrder(color);
                                                if (color.trim()) {
                                                    setError((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.buttonColor;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="ticketInventory"
                                                className="form-label"
                                            >
                                                Track Inventory
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="ticketInventory"
                                                    checked={trackInventory} onChange={() => setTrackInventory(!trackInventory)}
                                                />
                                                <label
                                                    htmlFor="ticketInventory"
                                                    className="form-check-label"
                                                >
                                                    Enable Inventory
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="isCombo" className="form-label">
                                                Is Combo
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isCombo"
                                                    checked={isCombo} onChange={() => setISCombo(!isCombo)}
                                                />
                                                <label htmlFor="isCombo" className="form-check-label">
                                                    Enable Combo
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="isShowtoCustomer" className="form-label">
                                                Show To Customer
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isshowtocustomer"
                                                    checked={isShowtoCustomer} onChange={() => setIsShowtoCustomer(!isShowtoCustomer)}
                                                />
                                                <label htmlFor="isShowtoCustomer" className="form-check-label">
                                                    Show to Customer
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label className="form-label">Weekday List</label>
                                            <div className="d-flex flex-wrap">
                                                {allWeekdays.map((day) => (
                                                    <div className="form-check me-3" key={day}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input ms-1"
                                                            id={day}
                                                            checked={weekdays[day] || false}
                                                            onChange={() => handleWeekdayChange1(day)}
                                                        />
                                                        <label htmlFor={day} className="form-check-label">{day}</label>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="isWaiver" className="form-label">
                                                Waiver Required
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isWaiver"
                                                    checked={waiverRequired} onChange={() => setWaiverRequired(!waiverRequired)}
                                                />
                                                <label htmlFor="isWaiver" className="form-check-label">
                                                    Waiver Required
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button
                                    onClick={handleSubmit}
                                    type="button"
                                    className="btn btn-primary me-3"
                                >
                                    Submit
                                </button>


                                <button data-bs-dismiss="modal" className="btn btn-light">Close</button>
                                {/* <button className="btn btn-primary" onClick={handleUpdateMachine} >Update</button> */}
                                {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CenterSalesTab salesTabId={salesTabId} trigger={trigger} />
{/* 
            <CenterSalesTab salesTabId={salesTabId} /> */}
            <ComboProduct fetchDetails={fetchDetails} />
        </div>
    );
};

export default ManageCenter;
